import {TXHR} from '../../assets/constants/constansts.type';

// Event type constants
export const EVENT_TYPES = {
    TICKET: 'ticket',
    AREA: 'area',
    HUB: 'hub',
    GIVECHAK: 'givechak',
    TIMETABLE: 'timetable',
    SUBSCRIPTION: 'subscription',
    TRANSPORT: 'transport',
    COURSE: 'course',
    CLUSTER: 'cluster',
    FRONTPAGE: 'frontpage',
    LISTING: 'listing',
    PRODUCT: 'product',
    TABLE: 'table',
    SCHEDULED:'scheduled',
} as const;

export type EventType = typeof EVENT_TYPES[keyof typeof EVENT_TYPES];

export interface TEvent {
    eid: number | null;
    active: boolean | null;
    type: EventType | null;
    name: string | null;
    userEventRole: string | null;
    category: string | null;
    currency: string | null;
    currencySymbol: string | null;
    description: string | null;
    fbImg: string | null;
    lang: string | null;
    location: string | null;
    locationMap: any | null;
    mailingJson: any | null;
    ev: any | null;
    hash: string | null;
    packageTitle: string | null;
    pid: number | null;
    ready: number | null;
    timeEnd: number | null;
    timeOpen: number | null;
    timeStart: number | null;
    timeZone: string | null;
    title: string | null;
    settings: {
        suspended?: {
            susStatus: boolean;
            customerConfirmation: boolean;
        };
        [key: string]: any;
    } | null;
    budgetIndex: number | null;
    domain: string | null;
    halls: any[] | null;
    artists: any[];
    map: Record<string, any>;
    hasBillingsTransaction: boolean | null;
    hasSuspendedTransaction: boolean | null;
    hasScheduledOrPriceFloatTicket: boolean | null;
    hasScheduledTicket: boolean | null;
    hasWhatsappAccess: boolean | null;
    updated: boolean;
    aiImages: any | null;
    colors: string[];
    maps: any[];
    fullDescription: string | null;//for subscription

    // XHR states
    getEventSettingsXHR: TXHR;
    getArtistXHR: TXHR;
    sendMapXHR: TXHR;
    getHallsXHR: TXHR;
    getHallEventXHR: TXHR;
    updateEventDetailsXHR: TXHR;
    updateEventDetailsFullXHR: TXHR;
    createDesignImageFullXHR: TXHR;
    getSuspendedXHR: TXHR;
    updateEventActiveXHR: TXHR;
    createTopSectionImageXHR: TXHR;
    createSalePageImage: {
        digitalArtXHR: TXHR;
        realisticXHR: TXHR;
        oilPaintingXHR: TXHR;
        PicassoStyleXHR: TXHR;
        threeDXHR: TXHR;
        humorXHR: TXHR;
    };
    getAiImagesXHR: TXHR;
    getDescriptionFromJPTXHR: TXHR;
    getEventXHR: TXHR;
    createDesignImageXHR: TXHR;
    updateDesignPopXHR: TXHR;
    getDescriptionFromGPTXHR: TXHR;
    eventDuplicationXHR: TXHR;
    addGooglePingXHR: TXHR;
    getImageColorsXHR: TXHR;
    updateMultipleAccountXHR: TXHR;
    getAccountsXHR: TXHR;
}
